var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('loader',{attrs:{"is-loading":_vm.loading.formData}}),_vm._v(" "),(_vm.accountFormShowing)?[_c('create-account-form')]:_vm._e(),_vm._v(" "),(_vm.profileFormShowing)?[_c('profile-form')]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }